import { Component, computed, input, Input, InputSignal, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { Store } from '@ngrx/store';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormValue,
  occupationsToFormValue
} from '../sections/location-of-devices-unrelated-to-road-occupation-data-section/forms/location-of-devices-unrelated-to-road-occupation.form';
import {
  LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent
} from '../sections/location-of-devices-unrelated-to-road-occupation-data-section/components/location-of-devices-unrelated-to-road-occupation-preview/location-of-devices-unrelated-to-road-occupation-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import { ApplicationPayment } from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    DecisionDataPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent,
    PaymentsDataPreviewComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-preview.component.html'
})
export class LocationOfDevicesUnrelatedToRoadPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public roadOccupation: Signal<LocationOfDevicesUnrelatedToRoadOccupationFormValue | null> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []).at(0) || null);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  constructor(private store$: Store) {
  }

  public ngOnInit(): void {
  }

}
